var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5847 3.18877C21.8455 3.37672 22 3.67856 22 4.00001V18C22 18.3788 21.786 18.725 21.4472 18.8944L15.4472 21.8944C15.1657 22.0352 14.8343 22.0352 14.5528 21.8944L8.92327 19.0797L3.31623 20.9487C3.01128 21.0503 2.67606 20.9992 2.41529 20.8113C2.15452 20.6233 2 20.3215 2 20V6.00001C2 5.56958 2.27543 5.18744 2.68377 5.05132L8.68377 3.05132C8.88904 2.9829 9.11096 2.9829 9.31623 3.05132L15 4.94591L20.6838 3.05132C20.9887 2.94967 21.3239 3.00081 21.5847 3.18877ZM14 6.72077L10 5.38743V17.382L14 19.382V6.72077ZM16 19.382L20 17.382V5.38743L16 6.72077V19.382ZM8 17.2792V5.38743L4 6.72077V18.6126L8 17.2792Z",
  fill: "#3F7F7D"
})));
export { SvgMapIcon as ReactComponent };
export default __webpack_public_path__ + "assets/6927c9f4.svg";